export default function Inputbox({
  disabled = false,
  inputClass = 'bg-[#FDFDFD]',
  title,
  titleClass = 'text-[#424242]',
  placeholder,
  value,
  onChange,
}) {
  return (
    <div className="w-full space-y-1">
      <div
        className={`font-[poppins] text-xs ${titleClass} font-normal leading-[20px] tracking-[0%]`}
      >
        {title}
      </div>
      <input
        type="text"
        disabled={disabled}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`w-full font-[poppins] text-sm placeholder-[#A4A7AE] text-[#414651] font-normal focus:outline-none focus:border-[#414651] border border-[#C2C2C2] ${inputClass} py-2 px-3 rounded-[10px]`}
      />
    </div>
  );
}
